import { render, staticRenderFns } from "./BrandActivity.vue?vue&type=template&id=5472562a&scoped=true&"
import script from "./BrandActivity.vue?vue&type=script&lang=js&"
export * from "./BrandActivity.vue?vue&type=script&lang=js&"
import style0 from "./BrandActivity.vue?vue&type=style&index=0&id=5472562a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472562a",
  null
  
)

export default component.exports